import React from 'react';
import './../../../Styles/Main/ProfilePage/ProfileInfoTab.scss';
import { personalInfo } from './../../../Constant/index';
import MyButton from '../../../UI/button/MyButton';

function ProfileInfoTab() {
   return (
      <div className='profileInfo__body'>
         {Object.keys(personalInfo).map(item => (
            <div
               className="profileInfo__column"
               key={item}
            >
               <div className="profileInfo__signature signature">{item}</div>
               <div className="profileInfo__personalInfo text">{ personalInfo[item] }</div>
            </div>
         ))}
         <div className="profileInfo__column">
            <div className="profileInfo__password">edit password</div>
         </div>
         <div className="profileInfo__column">
            <div className="profileInfo__button">
               <MyButton
                  style={{ fontSize: '20px', fontWeight: 700, backgroundColor: '#DDE3EB' }}
               >
                  Edit
               </MyButton>
            </div>
         </div>
      </div>
   );
}
export default ProfileInfoTab;